import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { finalize, map } from 'rxjs/operators';
import { InvestigationFormRepository } from '../../../infrastructure/repositories/investigation-form.repository';
import { InvestigationFormState } from '../../states/investigation-form.state';
import { FieldConstraintTypeResponseDto } from '../../../infrastructure/dtos/field-constraint-type-response.dto';
import { InvestigationFormMapper } from '../../../infrastructure/mappers/investigation-form.mapper';

@Injectable({ providedIn: 'root' })
export class GetFieldConstraintTypesUseCase {
  private readonly _repository = inject(InvestigationFormRepository);
  private readonly _state = inject(InvestigationFormState);

  public execute(): Observable<FieldConstraintTypeResponseDto[]> {
    const cachedConstraints = this._state.fieldConstraintTypes();
    if (cachedConstraints.length > 0) {
      return of(cachedConstraints);
    }

    this._state.setLoadingFieldConstraintTypes(true);

    return this._repository.getFieldTypes().pipe(
      map((fieldTypes) => {
        this._state.setFieldTypes(fieldTypes);
        const constraints = InvestigationFormMapper.flattenFieldTypeConstraints(fieldTypes);
        this._state.setFieldConstraintTypes(constraints);
        return constraints;
      }),
      finalize(() => this._state.setLoadingFieldConstraintTypes(false))
    );
  }
}
